export default "__VITE_ASSET__f0x5vB5z__"